export default (node) => {
  /**
   * Data + elements
   */
  const multiselects = node.querySelectorAll('[data-multiselect]');
  const multiselectValues = Array.from(
    node.querySelectorAll('[data-multiselect-value]')
  );

  /**
   * Functions
   */
  const handleSelection = (e, multiselectValue) => {
    // Add checked value to the hidden multiselect value
    const checkedValue = e.target.value;
    const isChecked = e.target.checked;

    if (isChecked) {
      // create array of values
      const tempArray = multiselectValue.value
        .split(',')
        .filter((value) => value.length);
      // add new value to array
      tempArray.push(checkedValue);
      // join array to string
      multiselectValue.value = tempArray.join(',');
    }

    if (!isChecked) {
      // create array of values
      let tempArray = multiselectValue.value
        .split(',')
        .filter((value) => value.length);
      // remove value from array
      tempArray = tempArray.filter((value) => value !== checkedValue);
      // join array to string
      multiselectValue.value = tempArray.join(',');
    }
  };
  /**
   * Init
   */
  const init = () => {
    multiselects.forEach((multiselect) => {
      const relatedAttribute = multiselect.dataset.multiselect;
      const multiselectValue = multiselectValues.find(
        (value) => value.dataset.multiselectValue === relatedAttribute
      );
      multiselect.addEventListener('change', (e) =>
        handleSelection(e, multiselectValue)
      );
    });
  };

  init();
};
